import sha1 from "js-sha1";

/**
 * Returns generated company logo image url
 */
export default function getCompanyLogo(adminAssetsBaseUrl: string, companyId: number) {
    let crypto = sha1.create();
    crypto.update(`${companyId}joijlkj3423l4iulkj2m3lk4nmb2nvbvc2b34v23`);
    return `${adminAssetsBaseUrl}/assets/company_images/${crypto.hex()}.jpg`
}